export * from './consultation.component';
